import React from 'react';
import { Container, Grid, Paper, Typography, TextField, Button, Box, useTheme, useMediaQuery } from '@mui/material';
import MapIcon from '@mui/icons-material/Map';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

const Contacts = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <section id="content" style={{ padding: theme.spacing(4, 0) }}>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h4" gutterBottom align="center">
              Find Us
            </Typography>
            <Paper elevation={3} style={{ height: '400px', borderRadius: theme.shape.borderRadius }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4787.753440043756!2d106.8937510842785!3d-6.190514444639693!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f4c66986bae1%3A0x1863fcd3a2d7a797!2sJl.%20Jati%20Klp.%20No.31%2C%20RT.8%2FRW.4%2C%20Jati%2C%20Kec.%20Pulo%20Gadung%2C%20Kota%20Jakarta%20Timur%2C%20Daerah%20Khusus%20Ibukota%20Jakarta%2013220!5e1!3m2!1sid!2sid!4v1723739018747!5m2!1sid!2sid"
                width="100%"
                height="100%"
                allowFullScreen
                loading="lazy"
                title="Google Maps"
                style={{ border: 0 }}
              ></iframe>
            </Paper>
          </Grid>

          <Grid item xs={12} md={5}>
            <Typography variant="h5" gutterBottom>
              Contact Info
            </Typography>
            <Typography variant="body1" paragraph>
              Thank you for your interest in AstroSphere Group. For any inquiries or further information, please feel free to contact us using the details below:
            </Typography>
            <Box>
              <Typography variant="body1" paragraph>
                <MapIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                ZodiakID <br />
                <br />
              </Typography>
              <Typography variant="body1" paragraph>
                <PhoneIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                Telephone: +62 8962 8127 896
              </Typography>
              <Typography variant="body1" paragraph>
                <EmailIcon sx={{ verticalAlign: 'middle', mr: 1 }} />
                E-mail: <a href="mailto:herdiyanitdev@gmail.com">herdiyanitdev@gmail.com</a>
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={7}>
            <Typography variant="h5" gutterBottom>
              Contact Form
            </Typography>
            <Box component="form" noValidate autoComplete="off" sx={{ mt: 2 }}>
              <TextField
                fullWidth
                label="Name"
                name="name"
                margin="normal"
                required
                variant="outlined"
              />
              <TextField
                fullWidth
                label="E-mail"
                name="email"
                margin="normal"
                required
                type="email"
                variant="outlined"
              />
              <TextField
                fullWidth
                label="Phone"
                name="phone"
                margin="normal"
                required
                type="tel"
                variant="outlined"
              />
              <TextField
                fullWidth
                label="Message"
                name="message"
                margin="normal"
                required
                multiline
                rows={4}
                variant="outlined"
              />
              <Box display="flex" justifyContent="flex-end" mt={2}>
                <Button type="reset" variant="outlined" color="secondary" sx={{ mr: 2 }}>
                  Clear
                </Button>
                <Button type="submit" variant="contained" color="primary">
                  Send
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Typography variant="body2" align="center" sx={{ mt: 4 }}>
          © ZodiakID - 2024
        </Typography>
      </Container>
    </section>
  );
};

export default Contacts;
